import React, { FC } from 'react';

import { ButtonProps } from '@material-ui/core/Button';

import { RouteName } from '../../../../config/clientRoutes/types';
import { useHistory } from 'react-router';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { Button } from '@material-ui/core';

type Props = ButtonProps & {
  to: RouteName;
  params?: { [key: string]: string | undefined };
};

const LinkButton: FC<Props> = ({ to, params = undefined, color = 'secondary', ...restProps }) => {
  const { getPath } = useI18nPath();
  const { push } = useHistory();

  return getPath(to) != null ? (
    <Button
      variant="text"
      color={color}
      disableTouchRipple
      onClick={() => push(getPath(to, params))}
      {...restProps}
    />
  ) : null;
};

export default LinkButton;
